import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000 // 5 minutes

// The single super admin hellobar message edited at /admin/hellobar.
// See app/controllers/api/v1/admin/hellobar_controller.rb.
export const useAdminHellobarStore = defineStore('adminHellobar', {
  state: () => ({
    data: null,
    fetchedAt: null,
    loading: false,
    error: null,
    saving: false,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid && this.data) return
      await this.fetchData()
    },

    async fetchData() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/admin/hellobar', {}, false)
        if (!res.js_error && res.response.success) {
          this.data = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load the hellobar.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    // Returns { ok: true } or { ok: false, errors: [...] } so the page can show
    // validation messages next to the form.
    async save({ message, active, color, emoji }) {
      this.saving = true
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('PUT', '/api/v1/admin/hellobar', {
          hellobar: { message, active, color, emoji: emoji || '' },
        }, false)
        if (!res.js_error && res.response.success) {
          this.data = res.response.data
          this.fetchedAt = Date.now()
          return { ok: true }
        }
        const errors = Array.isArray(res.response?.data) && res.response.data.length
          ? res.response.data
          : ['Could not save the hellobar.']
        return { ok: false, errors }
      } catch {
        return { ok: false, errors: ['Something went wrong.'] }
      } finally {
        this.saving = false
      }
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
